import {createAction} from '@reduxjs/toolkit';

const CLEAN_ATTRIBUTES_INFO = 'CLEAN_ATTRIBUTES_INFO';

export const cleanAttributesInfo = createAction(CLEAN_ATTRIBUTES_INFO);
